module.exports = __webpack_public_path__ + "img/Southwest_Quinoa.aa299cfa.jpg";